module.exports = __webpack_public_path__ + "static/shiitake-bacon-tacos-2.0e951908.jpg";